import './App.css';
import React, { useState, useEffect, useRef } from "react";
import RoundEdgeButton from './RoundEdgeButton';
import ImageSlider from './components/ImageSlider';
import OnsiteVerifyingPage from './OnsiteVerifyingPage';
import InputName from './InputName';
import ControllerPage from './ControllerPage';
import WebSocketConnection from './WebSocketConnection';

function importAllAvatarImgs() {
    try {
        const context = require.context('./images/avatarIcons', false, /\.(png|jpe?g|svg)$/);
        const keys = context.keys();
        const images = keys.sort().map((key) => context(key));
        return images;
    } catch (error) {
        console.error('❌ Error loading images:', error);
        return [];
    }
}

// Load images ONCE, outside the component
const AVATAR_IMAGES = importAllAvatarImgs();

function App() {
    const onsiteCheckInText = "OnsiteVerifyingPage";
    const mainPageInText = "MainPage";
    const controllerPageInText = "ControllerPage";
    const [playerName, setPlayerName] = useState("");

    // Use the pre-loaded images instead of importing on every render
    const images = AVATAR_IMAGES;

    const [iconIndex, setIconIndex] = useState("");

    const handleSelect = (index) => { setIconIndex(index); };

    //-------------------------- start of Input Validation
    const [errorMessages, setInputErrorMsgs] = useState({});
    const [lastErrMsg, setLastErrorMsgs] = useState({});
    const getErrorMsg = (msgIndex, errorMsg) => {
        setInputErrorMsgs(prevErrors => ({
            ...prevErrors,
            [msgIndex]: errorMsg,
        }));
    };

    const hasErrors = Object.values(errorMessages).some(message => message !== '');
    useEffect(() => {
        const errorValues = Object.values(errorMessages).filter(msg => msg !== '');

        if (errorValues.length > 0) {
            setLastErrorMsgs(errorValues[errorValues.length - 1]);
        } else
            setLastErrorMsgs('');
    }, [errorMessages]);
    //-------------------------- end of Input Validation
    const isThereError = () => {
        let combinedErrMsg = Object.values(errorMessages).join("").trim();
        return combinedErrMsg === '' ? false : true;
    };

    const [messages, setMessages] = useState([]);
    const [socket, setSocket] = useState(null);
    const clientIDRef = useRef("");
    const [currentPage, setCurrentPage] = useState(mainPageInText);

    // NEW: Track connection token from OnsiteVerifyingPage
    const [connectionToken, setConnectionToken] = useState(null);

    // NEW: Track auth callback for current page
    const [authFailed, setAuthFailed] = useState(false);

    const handleAuthorization = (_isAuthorized) => {
        if (_isAuthorized === true) {
            // Auth succeeded - navigate to controller page
            setCurrentPage(controllerPageInText);
            setAuthFailed(false);
        } else {
            // Auth failed - send back to verification page
            setCurrentPage(onsiteCheckInText);
            setAuthFailed(true);
            setConnectionToken(null); // Allow retry
        }
    };

    const handleMessagesUpdate = (newMessage) => {
        setMessages(prev => [...prev, newMessage]);
    };

    // Extract userID from messages
    const getResponseMsg = () => {
        if (messages.length === 0) return null;
        const latestMessage = messages[messages.length - 1];
        try {
            const parsedMessage = JSON.parse(latestMessage);
            return parsedMessage.Content;
        } catch (error) {
            console.error("Failed to parse message:", error);
            return null;
        }
    };
    const inputMsg = getResponseMsg();

    let playerInputUIContent =
        (<div >
            <div style={{ marginTop: '-30px', marginBottom: '10px', textAlign: 'center' }}>
                <p>Use any letter or digit to fill the 3 blank fields and represent yourself in the game!</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <InputName onGetPlayerName={setPlayerName} onGetErrorMsg={getErrorMsg} />
                <RoundEdgeButton
                    onClick={() => { setCurrentPage(onsiteCheckInText); }}
                    variant='roundEdgeInBlack'
                    isDisabled={isThereError()}
                >
                    &#x21e8;
                </RoundEdgeButton>

            </div>
            <div>
                {hasErrors ? (<p style={{ color: 'red', textAlign: 'center' }}>{lastErrMsg}</p>) : null}
            </div>
        </div>)

    let content;
    if (currentPage === mainPageInText) {
        content =
            <div className="alignedCenter">
                <h1>Tap an icon to select</h1>
                <ImageSlider images={images} onSelect={handleSelect} />
                {playerInputUIContent}
            </div>
    }
    else if (currentPage === onsiteCheckInText) {
        content = (
            <div>
                <OnsiteVerifyingPage
                    onStartConnection={setConnectionToken}
                    authFailed={authFailed}
                    onResetAuthFailed={() => setAuthFailed(false)}
                />
            </div>
        );
    }
    else if (currentPage === controllerPageInText) {
        content = (
            <div>
                <ControllerPage
                    socket={socket}
                    clientIDRef={clientIDRef}
                    playerName={playerName}
                    image={images[iconIndex]}
                    iconIndex={iconIndex}
                    inputMsg={inputMsg}
                />
            </div>
        );
    }

    return (
        <div>
            {connectionToken && (
                <WebSocketConnection
                    token={connectionToken}
                    setSocket={setSocket}
                    clientIDRef={clientIDRef}
                    onMessagesUpdate={handleMessagesUpdate}
                    onAuthorizationResult={handleAuthorization}
                    playerName={playerName}
                    iconIndex={iconIndex}
                />
            )}
            {content}
        </div>
    );
}
export default App;